var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 11,
    viewBox: "0 0 34 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M16.504.192l-2.227 10.477h-2.694L13.812.192h2.692zm11.333 6.765l1.417-3.934.817 3.934h-2.234zm3.005 3.712h2.491L31.16.192h-2.3c-.516 0-.952.302-1.146.768l-4.041 9.71h2.827l.562-1.566h3.456l.325 1.565zm-7.03-3.42c.012-2.766-3.8-2.918-3.774-4.154.009-.376.364-.775 1.143-.877.385-.051 1.45-.09 2.655.468L24.31.464A7.199 7.199 0 0 0 21.79 0c-2.662 0-4.536 1.424-4.55 3.463-.018 1.51 1.337 2.35 2.358 2.852 1.049.514 1.4.843 1.397 1.302-.008.704-.838 1.014-1.613 1.026-1.354.021-2.14-.369-2.766-.662l-.488 2.296c.629.29 1.79.544 2.996.556 2.83 0 4.68-1.406 4.689-3.585zM12.656.191L8.292 10.669H5.445L3.297 2.307c-.13-.514-.243-.703-.64-.92C2.01 1.033.941.701 0 .495L.063.192h4.584c.584 0 1.11.39 1.242 1.068l1.134 6.063L9.827.192h2.829z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1D1C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#174489"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.333 .167)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M16.504.192l-2.227 10.477h-2.694L13.812.192h2.692zm11.333 6.765l1.417-3.934.817 3.934h-2.234zm3.005 3.712h2.491L31.16.192h-2.3c-.516 0-.952.302-1.146.768l-4.041 9.71h2.827l.562-1.566h3.456l.325 1.565zm-7.03-3.42c.012-2.766-3.8-2.918-3.774-4.154.009-.376.364-.775 1.143-.877.385-.051 1.45-.09 2.655.468L24.31.464A7.199 7.199 0 0 0 21.79 0c-2.662 0-4.536 1.424-4.55 3.463-.018 1.51 1.337 2.35 2.358 2.852 1.049.514 1.4.843 1.397 1.302-.008.704-.838 1.014-1.613 1.026-1.354.021-2.14-.369-2.766-.662l-.488 2.296c.629.29 1.79.544 2.996.556 2.83 0 4.68-1.406 4.689-3.585zM12.656.191L8.292 10.669H5.445L3.297 2.307c-.13-.514-.243-.703-.64-.92C2.01 1.033.941.701 0 .495L.063.192h4.584c.584 0 1.11.39 1.242 1.068l1.134 6.063L9.827.192h2.829z",
    mask: "url(#c)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.5c5c5a77.svg";
export { ForwardRef as ReactComponent };